/**
 * Bilgi bankası (shop.kb_entries) for the panel: GET /kb lists every entry with its
 * products; POST /kb/{id}/approve turns a draft into an approved answer (optionally with
 * Sercan's edited text), POST /kb/{id}/retire retires a draft or an approved entry. Only
 * approved entries reach the Temsilci (kb_search), so approval is Sercan's decision.
 */
import { z } from 'zod';
export const KB_STATUSES = ['draft', 'approved', 'conflict', 'retired'];
export const kbProductRefSchema = z.strictObject({
    productId: z.string(),
    sku: z.string(),
    title: z.string(),
    status: z.string(),
    listingIds: z.array(z.string()),
});
export const kbEntrySchema = z.strictObject({
    id: z.string(),
    pattern: z.string(),
    status: z.enum(KB_STATUSES),
    version: z.number().int(),
    questionExamples: z.array(z.string()),
    answerEn: z.string(),
    answerTr: z.string(),
    tags: z.array(z.string()),
    /** Where the answer comes from (document, Etsy listing, R2 file ...), as written by the import. */
    sources: z.array(z.record(z.string(), z.unknown())),
    products: z.array(kbProductRefSchema),
    approvedBy: z.string().nullable(),
    approvedAt: z.number().nullable(),
    updatedAt: z.number(),
});
export const kbViewSchema = z.strictObject({
    asOf: z.number(),
    entries: z.array(kbEntrySchema),
    counts: z.strictObject({
        draft: z.number().int(),
        approved: z.number().int(),
        conflict: z.number().int(),
        retired: z.number().int(),
    }),
});
/** POST /kb/{id}/approve: the answer as Sercan leaves it (unchanged fields omitted). */
export const kbApproveBodySchema = z.strictObject({
    answerEn: z.string().trim().min(1).max(6000).optional(),
    answerTr: z.string().trim().min(1).max(6000).optional(),
});
export const kbDecisionResponseSchema = z.strictObject({
    kbEntryId: z.string(),
    status: z.enum(KB_STATUSES),
});
//# sourceMappingURL=kb.js.map